import { useRef } from "react";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import ApsInstallmentContent from "./ApsInstallmentContent";
import { MdClose } from "react-icons/md";

const ApsInstallmentModal = ({ locale, show, setShow }) => {
  const ref = useRef();
  useOnClickOutside([ref], () => setShow(false));

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[999999] overflow-y-hidden bg-black/50">
      <div className="min-h-full flex items-center justify-center py-6">
        <div
          ref={ref}
          className="relative bg-white rounded-3xl shadow-lg max-w-[1000px] w-[90vw] p-6 md:py-10 md:px-14"
        >
          <div
            className={`bg-[#F2F2F2] rounded-full p-1 absolute top-4 cursor-pointer ${
              locale === "ar" ? "left-4" : "right-4"
            }`}
          >
            <MdClose
              className="text-[#888585]"
              onClick={() => setShow(false)}
              width={12}
              height={12}
            />
          </div>
          <ApsInstallmentContent locale={locale} />
        </div>
      </div>
    </div>
  );
};

export default ApsInstallmentModal;
